<div class="size-picker">
  <button
    class="size-picker__button"
    mat-flat-button
    color="accent"
    *ngFor="let size of sizes"
    (click)="onChangeSize(size)"
    [ngClass]="{'is-active': size === currentSize}"
  >
    {{ size.sizeName }}
  </button>
</div>
